export class ClassBookFolder {
    constructor(
      public id: string,
      public name: string,
      public description: string,
      public order: number,
    ) { }
  }



// WEBPACK FOOTER //
// ./src/app/settings/class-book-folders/shared/class-book-folder.model.ts